import { createSlice } from '@reduxjs/toolkit';
import retriggerPathologyAI from '@custom/rtk-apis/microscopy/retriggerPathologyAI';

const retriggerPathologyAISlice = createSlice({
  name: 'retriggerPathologyAI',
  initialState: {
    status: '',
    msg: '',
    loading: false,
  },
  reducers: {
    clearRetriggerState: (state) => {
      state.status = '';
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(retriggerPathologyAI.pending, (state) => {
        state.loading = true;
        state.status = '';
      })
      .addCase(retriggerPathologyAI.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.status = payload?.status || '';
        state.msg = payload?.msg || '';
      })
      .addCase(retriggerPathologyAI.rejected, (state) => {
        state.loading = false;
        state.status = 'ERROR';
      });
  },
});

export default retriggerPathologyAISlice.reducer;
export const { clearRetriggerState } = retriggerPathologyAISlice.actions;
